import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const modalMargin = css`
  .MuiDialog-container {
    height: 100%;
    overflow-y: visible;
    display: flex;

    > div {
      max-height: 575px;
    }
  }
`;

export const breadcrumbs = css`
  background-color: rgba(244, 247, 249, 0.5);
  padding: 10px 0;
  margin-top: -10px;

  .MuiBreadcrumbs-separator:hover {
    color: ${colors.gray.default};
  }
`;

export const stepContentWrapper = css`
  height: 400px;
`;

export const buttonGroup = css`
  display: flex;
  margin-top: 20px;
  padding: 0 20px;
`;

export const stepIconButton = css`
  > span {
    display: flex;
    gap: 10px;
    align-items: center;
  }
`;

export const rightButtonGroup = css`
  display: flex;
  margin-left: auto;

  button:not(:first-child) {
    margin-left: 30px;
  }
`;
